import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2e1e4a0c&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import "./Dashboard.vue?vue&type=style&index=0&id=2e1e4a0c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e4a0c",
  null
  
)

export default component.exports